"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const raise = (error) => {
    if (typeof error === 'string') {
        error = new Error(error);
    }
    throw error;
};
exports.default = raise;
//# sourceMappingURL=Raise.js.map